import { FC, ReactNode } from 'react'
import { Avatar, Button, List } from 'antd'
import { X } from '@phosphor-icons/react'

export interface IProduct {
  id: string
  name: string
  photo: string
  description: string
  disabled?: boolean
}

interface ProductProps {
  product: IProduct
  hanleSelect?: (value: string) => void
  hanleDelete?: (value: string) => void
}

const Product: FC<ProductProps> = ({ product, hanleSelect, hanleDelete }) => {
  const getActionsItem = () => {
    const actions: ReactNode[] = []
    if (hanleDelete) actions.push(<Button type='text' icon={<X />} onClick={() => hanleDelete(product.id)} />)

    return actions
  }

  return (
    <List.Item
      actions={getActionsItem()}
      onClick={() => !product.disabled && hanleSelect?.(product.id)}
      style={{
        cursor: product.disabled ? 'not-allowed' : 'pointer',
        opacity: product.disabled ? 0.5 : 1,
        backgroundColor: product.disabled ? '#f5f5f5' : 'transparent'
      }}
    >
      <List.Item.Meta
        avatar={<Avatar shape='square' size={46} src={product.photo} />}
        title={product.name}
        description={product.description}
      />
    </List.Item>
  )
}

export default Product
